import flowRight from "lodash/fp/flowRight";
import moment from "moment";
import { fillOperands, mapOperator } from "@/utils/queryPyConverter";

const objectToArray = (filters) => Object.keys(filters).map((item) => filters[item]);
const timeZoneOffsetForDate = (filtersList) => {
  const offset = (new Date()).getTimezoneOffset();
  return filtersList.map((item) => {
    if (item.leftOperand === "DATE") {
      const currentValue = new Date(item.value);
      if (item.operator === ">=")
        return {
          ...item,
          value: moment
            .utc(
              new Date(
                currentValue.getFullYear(),
                currentValue.getMonth(),
                currentValue.getDate(),
                currentValue.getHours(),
                currentValue.getMinutes() + offset
              )
            )
            .format("YYYY-MM-DD"),
        };
      else if (item.operator === "<=")
        return {
          ...item,
          value: moment
            .utc(
              new Date(
                currentValue.getFullYear(),
                currentValue.getMonth(),
                currentValue.getDate(),
                currentValue.getHours(),
                currentValue.getMinutes() - offset
              )
            )
            .format("YYYY-MM-DD"),
        };
    }

    return item;
  });
};
const removeEmptyFilters = (filtersList) => filtersList.filter((item) => item.value);

const constructSyntax = (filters) => {
  const preprocess = flowRight([timeZoneOffsetForDate, removeEmptyFilters, objectToArray]);
  const preprocessedFilters = preprocess(filters);
  return Object.keys(preprocessedFilters)
    .map((key) =>
      fillOperands(
        preprocessedFilters[key].leftOperand,
        preprocessedFilters[key].value,
        mapOperator(preprocessedFilters[key].operator)
      )
    )
    .join(" and ");
};

export { constructSyntax };
